import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const beneficios = ['Respirar bajo el agua con total tranquilidad.', 'Bucear rodeado de peces tropicales.', 'Explorar arrecifes impresionantes.', 'Descubrir una parte del planeta que la mayoría nunca llega a conocer.', 'Viajar por el mundo con una certificación reconocida internacionalmente.'];
export function Experiencia() {
  return <section className="py-28 sm:py-36 px-6 bg-brand-background relative overflow-hidden" data-id="element-149">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-150">
        {/* Title + intro */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl" data-id="element-151">
          <h3 className="text-brand-primary font-heading font-black text-4xl sm:text-5xl md:text-6xl uppercase tracking-tight leading-[1.05] mb-6" data-id="element-152">
            Mucho más que una certificación de buceo
          </h3>
          <p className="text-white/90 text-xl sm:text-2xl font-light leading-relaxed" data-id="element-153">
            Hoy estás reservando un curso. En pocos meses podrías estar viviendo
            esto.
          </p>
        </motion.div>

        {/* Hero photo — the visual protagonist */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mt-10 sm:mt-12 relative rounded-3xl overflow-hidden aspect-[4/5] sm:aspect-[16/10]" data-id="element-154">
          <img src="https://cdn.magicpatterns.com/uploads/qLrjttfz2BAKHcupTfeqhd/FOTO_WEB.jpg" alt="Instructor buceando junto a un alumno bajo el agua, celebrando la inmersión" className="w-full h-full object-cover object-center" data-id="element-155" />
          <div className="absolute inset-0 bg-brand-background/20 mix-blend-multiply" data-id="element-156"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-brand-background/70 via-transparent to-transparent" data-id="element-157"></div>
        </motion.div>

        {/* Benefits */}
        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} className="mt-12 space-y-4 max-w-2xl" data-id="element-158">
          {beneficios.map((item, i) => <motion.li key={i} variants={{
          hidden: {
            opacity: 0,
            x: -16
          },
          visible: {
            opacity: 1,
            x: 0
          }
        }} className="flex items-center gap-3 text-white text-lg sm:text-xl font-light" data-id="element-159">
              <span className="w-7 h-7 rounded-full bg-brand-primary/15 border border-brand-primary/40 flex items-center justify-center shrink-0" data-id="element-160">
                <Check size={16} className="text-brand-primary" strokeWidth={3} data-id="element-161" />
              </span>
              {item}
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}